module.exports = __webpack_public_path__ + "img/手表-4.2c29619e.png";